import React from 'react';

import './avatar-list.styl'

class AvatarList extends React.Component {
  render(){
    return (
      <ul className="avatar-list">
        { this.props.items.map(item => {
            return (
              <li key={ item.key } className="avatar-list__item">
                <div className="avatar-list__item__avatar z-depth-1">
                  <img src={ item.avatar } alt={ item.avatarAlt } />
                </div>
                <div className="avatar-list__item__text">
                  <p dangerouslySetInnerHTML={{ __html: item.text }} />
                </div>
              </li>
            );
          })
        }
      </ul>
    );
  }
}

export default AvatarList;



// WEBPACK FOOTER //
// ./src/components/avatar-list/avatar-list.js